import { c as _c } from "react/compiler-runtime";
import type { BillingInterval } from '@/types/billing-plan';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
type BillingCycleToggleProps = {
  value: BillingInterval;
  onChange: (value: BillingInterval) => void;
};
export function BillingCycleToggle(t0) {
  const $ = _c(7);
  const {
    value,
    onChange
  } = t0;
  let t1;
  if ($[0] !== onChange) {
    t1 = v => {
      if (v === "monthly" || v === "yearly") {
        onChange(v);
      }
    };
    $[0] = onChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <TabsTrigger value="monthly" variant="white">Monthly</TabsTrigger>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <TabsList>{t2}<TabsTrigger value="yearly" variant="white">Yearly <span className="ml-1.5 text-zinc-400">-20%</span></TabsTrigger></TabsList>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1 || $[5] !== value) {
    t4 = <div className="flex justify-center"><Tabs value={value} onValueChange={t1}>{t3}</Tabs></div>;
    $[4] = t1;
    $[5] = value;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}